import { ReactElement } from "react";
import * as React from "react";

import useProductTypes from "../../../hooks/query/use-product-types";
import useText from "../../../hooks/use-text";
import { LocalizedStrings, SupportedLanguages } from "../../../utils/lang";
import MetaSelect from "../parts/meta-select";

type Props = {
  onChangeProductTypes(productTypesId?: string): void;
};

export default function ProductTypeSelector(props: Props): ReactElement {
  const { onChangeProductTypes } = props;

  const { strings } = useText(local);
  const { data, loading } = useProductTypes();

  if (loading || !data) {
    return <></>;
  }

  const { items: productTypes } = data.productTypes;

  return (
    <MetaSelect
      label={strings.label}
      name="value"
      getOptions={productTypes}
      setOption={(v): void => onChangeProductTypes(v["value"])}
      list={productTypes.map((v): { text: string; value: string } => ({
        text: v.name,
        value: v.id,
      }))}
    />
  );
}

type LocalSchema = {
  label: string;
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    label: "Product Type",
  },
};
